import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import Title from '../../Title';
import PlanningCard from './PlanningCard';
import { Button } from '@material-ui/core';

import { VariableSizeList } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

class PlanningList extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        label: PropTypes.string.isRequired,
        isExpandedDefault: PropTypes.bool,
        applications: PropTypes.array.isRequired,
        PlanningCardProps: PropTypes.object
    };

    static defaultProps = {
        PlanningCardProps: {}
    };

    constructor (props) {
        super(props);

        this.state = {
            isExpanded: props.isExpandedDefault
        };

        this.handleToggleExpand = this.handleToggleExpand.bind(this);
    }

    componentDidUpdate (prevProps, prevState, snapshot) {
        if (prevProps.applications != this.props.applications) {
            this.setState({
                isExpanded: this.props.isExpandedDefault
            });
        }
    }

    handleToggleExpand () {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    // 86 386

    render () {
        const { classes, label, applications, PlanningCardProps } = this.props;
        const { isExpanded } = this.state;

        const isLoading = !Boolean(applications);

        const GUTTER_SIZE = 10;
        const COLUMN_WIDTH = 100;
        const ROW_HEIGHT = 68;

        const getItemSize = index => 68 + GUTTER_SIZE;
        const Row = ({ index, style }) => (
            <div
                key={index}
                style={{
                    ...style,
                    top: style.top + GUTTER_SIZE,
                    height: style.height - GUTTER_SIZE
                }}
            >
                <PlanningCard application={applications[index]} {...PlanningCardProps} />
            </div>
        );

        const innerElementType = forwardRef(({ style, ...rest }, ref) => (
            <div
                ref={ref}
                style={{
                    ...style,
                    paddingTop: GUTTER_SIZE
                }}
                {...rest}
            />
        ));

        return (
            <>
                <Title
                    title={`${label} (${applications.length})`}
                    skeleton={isLoading}
                >
                    <Button
                        className={classes.expandButton}
                        onClick={this.handleToggleExpand}
                    >
                        {isExpanded ? 'Hide' : 'Show'}
                    </Button>
                </Title>
                {isExpanded && applications.map(e => <PlanningCard key={e.uid} application={e} {...PlanningCardProps} />)}
                {
                    // <AutoSizer>
                    //     {({height, width}) => {
                    // <VariableSizeList
                    //     height={500}
                    //     width={492}
                    //     itemCount={applications.length}
                    //     itemSize={getItemSize}
                    //     innerElementType={innerElementType}
                    // >
                    //     {Row}
                    // </VariableSizeList >
                    //     }}
                    // </AutoSizer>
                }
            </>
        );
    }
}

const style = theme => ({
    expandButton: {
        ...theme.typography.caption,
        marginLeft: 'auto',
        textTransform: 'initial'
    }
});

export default withStyles(style)(PlanningList);